import { faSortAmountDownAlt } from "@fortawesome/pro-regular-svg-icons";
import { faCheck, faList, faSearch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { Feed } from "@/mk2/apps/forum/components/Feed";
import { READ_FEED_TIMEOUT } from "@/mk2/apps/forum/constants";
import { FORUM_FEED_MENU_ORDERBY } from "@/mk2/apps/forum/containers/ForumFeed/ForumFeed.constants";
import {
    ORDER_BY_NEWEST,
    ORDER_BY_UPDATED,
    OrderBy,
} from "@/mk2/apps/forum/containers/ForumFeed/ForumFeed.reducers";
import { Props } from "@/mk2/apps/forum/containers/ForumFeed/ForumFeedPage";
import { forumSearchUrl, forumTopicsUrl, forumUpdatedUrl, forumUrl } from "@/mk2/apps/forum/urls";
import { homepageUrl } from "@/mk2/apps/home/urls";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { Link } from "@/mk2/components/Link";
import { ListItem } from "@/mk2/components/ListItem";
import { MenuItem } from "@/mk2/components/menu/MenuItem";
import { Menu } from "@/mk2/containers/Menu/Menu";
import {
    LIST_OF_FORUMS,
    NEWEST_DISCUSSIONS,
    SHORTENED_SEARCH_IN_FORUM,
    WHERE_ARE_DISCUSSIONS,
} from "@/mk/autogenerated/translation";

import styles from "./ForumFeed.mscss";

class ForumFeed extends React.PureComponent<Props> {
    private readTimer: number;

    public componentDidMount() {
        if (this.props.unreadCount) {
            this.readTimer = window.setTimeout(this.props.onRead, READ_FEED_TIMEOUT);
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.props.unreadCount) {
            window.clearTimeout(this.readTimer);
            this.readTimer = window.setTimeout(this.props.onRead, READ_FEED_TIMEOUT);
        }
    }

    public componentWillUnmount() {
        window.clearTimeout(this.readTimer);
    }

    public render() {
        const { onForumFeedMenuOrderBy, orderBy, topicsCount } = this.props;

        return (
            <div>
                <ListItem
                    isLast
                    className={styles.ForumFeed__list}
                    to={forumTopicsUrl}
                    icon={
                        <span className={styles.ForumFeed__list__icon}>
                            <FontAwesomeIcon icon={faList} />
                        </span>
                    }
                    count={topicsCount}
                >
                    {LIST_OF_FORUMS}
                </ListItem>

                <div className={styles.ForumFeed__orderAndSearch}>
                    <Link className={styles.ForumFeed__orderAndSearch__search} to={forumSearchUrl}>
                        <span className={styles.ForumFeed__orderAndSearch__search__icon}>
                            <FontAwesomeIcon icon={faSearch} />
                        </span>{" "}
                        {SHORTENED_SEARCH_IN_FORUM}
                    </Link>

                    <div className={styles.ForumFeed__orderAndSearch__orderBy}>
                        <Menu
                            menuId={FORUM_FEED_MENU_ORDERBY}
                            trigger={
                                <Btn
                                    className={styles.ForumFeed__orderAndSearch__orderBy__trigger}
                                    type={BtnType.BlackText}
                                    icon={faSortAmountDownAlt}
                                    onClick={onForumFeedMenuOrderBy}
                                />
                            }
                            triggerShadow={false}
                        >
                            <MenuItem
                                label={
                                    <span
                                        className={cx(
                                            styles.ForumFeed__orderAndSearch__orderBy__item,
                                            orderBy === ORDER_BY_NEWEST &&
                                                styles[
                                                    "ForumFeed__orderAndSearch__orderBy__item--active"
                                                ],
                                        )}
                                    >
                                        <FontAwesomeIcon
                                            className={cx(
                                                styles.ForumFeed__orderAndSearch__orderBy__item__icon,
                                                orderBy !== ORDER_BY_NEWEST &&
                                                    styles[
                                                        "ForumFeed__orderAndSearch__orderBy__item__icon--notActive"
                                                    ],
                                            )}
                                            icon={faCheck}
                                        />{" "}
                                        {NEWEST_DISCUSSIONS}
                                    </span>
                                }
                                onClick={this.handleOrderByNewest}
                            />
                            <MenuItem
                                label={
                                    <span
                                        className={cx(
                                            styles.ForumFeed__orderAndSearch__orderBy__item,
                                            orderBy === ORDER_BY_UPDATED &&
                                                styles[
                                                    "ForumFeed__orderAndSearch__orderBy__item--active"
                                                ],
                                        )}
                                    >
                                        <FontAwesomeIcon
                                            className={cx(
                                                styles.ForumFeed__orderAndSearch__orderBy__item__icon,
                                                orderBy !== ORDER_BY_UPDATED &&
                                                    styles[
                                                        "ForumFeed__orderAndSearch__orderBy__item__icon--notActive"
                                                    ],
                                            )}
                                            icon={faCheck}
                                        />{" "}
                                        {WHERE_ARE_DISCUSSIONS}
                                    </span>
                                }
                                onClick={this.handleOrderByUpdated}
                            />
                        </Menu>
                    </div>
                </div>

                <Feed
                    {...this.props}
                    onLoad={this.handleLoad}
                    showTopic
                    showCreated={orderBy === ORDER_BY_NEWEST}
                    readonlyPosts={false}
                    inFeed
                    failureBackButtonUrl={homepageUrl}
                />
            </div>
        );
    }

    private handleLoad = (after?: number) => {
        const { onLoad, orderBy } = this.props;
        onLoad(orderBy, after);
    };

    private handleOrderByNewest = () => {
        this.handleOrderBy(ORDER_BY_NEWEST);
    };

    private handleOrderByUpdated = () => {
        this.handleOrderBy(ORDER_BY_UPDATED);
    };

    private handleOrderBy = (orderBy: OrderBy) => {
        if (this.props.orderBy === orderBy) {
            return;
        }

        this.props.routeNavigate(orderBy === ORDER_BY_UPDATED ? forumUpdatedUrl : forumUrl, {
            replace: true,
        });
    };
}

export default ForumFeed;
